import * as React from 'react';

function SvgMicOffIcon(props: React.SVGProps<SVGSVGElement>) {
    return (
        <svg
            width="24px"
            height="24px"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            {...props}>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M8.15 11.659v-.798l1.494 1.555c.22.63.706 1.135 1.324 1.38l1.422 1.481a3.663 3.663 0 01-4.24-3.618zm5.961-5.496v4.359l1.356 1.412c.006-.091.01-.183.01-.275V6.163a3.663 3.663 0 00-7.001-1.512L9.549 5.77a2.298 2.298 0 014.562.393zm-2.262 10.92a5.408 5.408 0 001.924-.365l1.007 1.05a6.744 6.744 0 01-2.284.646v2.403a.683.683 0 01-1.365 0v-2.403a6.79 6.79 0 01-6.106-6.754V9.822a.683.683 0 011.366 0v1.838a5.423 5.423 0 005.458 5.422zm5.082-3.624l1.033 1.077c.41-.874.638-1.848.638-2.876V9.822a.683.683 0 10-1.366 0v1.838c0 .63-.107 1.236-.305 1.799zM4.903 3.28a.683.683 0 10-.985.946l15.179 15.68a.683.683 0 00.985-.945L4.903 3.282z"
                fill="currentColor"
            />
        </svg>
    );
}

export default SvgMicOffIcon;
